import { useSyncExternalStore } from "react"

import { type PwaFormFactor, pwaFormFactor } from "@/lib/pwa-device"

function subscribe() {
  return () => undefined
}

function currentFormFactor(): PwaFormFactor | null {
  if (typeof navigator === "undefined") return null
  return pwaFormFactor()
}

export function usePwaFormFactor() {
  return useSyncExternalStore(subscribe, currentFormFactor, () => null)
}
